import locationsConfig, {
    moduleName as locationsModuleName,
} from "./Locations/config";
import locationGroupsConfig, {
    moduleName as locationGroupsModuleName,
} from "./LocationGroups/config";
import permissionsConfig, {
    moduleName as permissionsModuleName,
} from "./Permissions/config";
import translateConfig, {
    moduleName as translateModuleName,
} from "./Translate/config";

import ProjectContext from "app/App/context";
import IConfig from "interfaces/IConfig";
import { registerModule } from "moduleConfig";
import { registerRoutings } from "rootRouting";
import { registerProjects } from "rootProjects";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "Gastrohub";
export const project = "gastrohub";
export const url = `/gastrohub`;

const getConfig = (permissions: permissionsType, settings: any) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    const routingChildrens = [];

    // register Locations module
    const locations = locationsConfig(permissions, url);
    if (locations.config.active) {
        config.active = true;

        registerModule(locationsModuleName, locations.config);
        routingChildrens.push(...locations.routing);
    }

    // register LocationGroups module
    const locationGroups = locationGroupsConfig(permissions, url);
    if (locationGroups.config.active) {
        config.active = true;

        registerModule(locationGroupsModuleName, locationGroups.config);
        routingChildrens.push(...locationGroups.routing);
    }

    // register permissions module
    const permissionsModule = permissionsConfig(permissions, url);
    if (permissionsModule.config.active) {
        config.active = true;

        registerModule(permissionsModuleName, permissionsModule.config);
        routingChildrens.push(...permissionsModule.routing);
    }

    //register Translate module
    const tr = translateConfig(permissions, url);
    if (tr.config.active) {
        registerModule(translateModuleName, tr.config);
        routingChildrens.push(...tr.routing);
        config.active = true;
    }

    if (routingChildrens.length > 0) {
        routing.push({
            path: url + "/*",
            children: routingChildrens,
            element: (
                <ProjectContext.Provider value={{ project, url }}>
                    <AsyncComponent path="Gastrohub/index" />{" "}
                </ProjectContext.Provider>
            ),
        });
    }

    if (config.active) {
        registerProjects([
            {
                id: project,
                name: "Gastrohub",
                icon: "forum",
                url: `${url}`,
                priority: 425,
            },
        ]);
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
